import "./App.css";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getUserRequest,
  logoutRequest,
} from "./features/Auth/slices/authActions";
import AppRoutes from "./app/routes";
import { NotificationProvider } from "./components/Notification/NotificationProvider";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const id = localStorage.getItem("id");
    if (id) dispatch(getUserRequest(id));
    else dispatch(logoutRequest());
  }, [dispatch]);

  // useEffect(() => {
  //   // Kết nối tới WebSocket server
  //   const socket = new WebSocket("ws://localhost:8080");

  //   socket.onopen = () => {
  //     console.log("Connected to WebSocket server");
  //   };

  //   socket.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     console.log("Received from server:", data);
  //   };

  //   socket.onerror = (error) => {
  //     console.error("WebSocket error:", error);
  //   };

  //   socket.onclose = () => {
  //     console.log("WebSocket connection closed");
  //   };

  //   return () => {
  //     socket.close();
  //   };
  // }, []);

  return (
    <NotificationProvider>
      <AppRoutes />
    </NotificationProvider>
  );
};

export default App;
